import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import TranslateIcon from '@mui/icons-material/Translate';
import { ProductOptionKey } from '../../../../interfaces/ProductOption/ProductOptionKey';
import { sharedStyles } from '../../../../utils/Style';
import { OptionValueChip } from './OptionValueChip';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import { UpsertOptionKeyDialog } from './UpsertOptionKeyDialog';
import { UpsertOptionValueDialog } from './UpsertOptionValueDialog';

interface OptionKeyCardProps {
  optionKey: ProductOptionKey;
  selectedLocale: string | null;
  onDelete: () => void;
  onUpdateName: (name: string) => void;
  onAddValue: (value: string) => void;
  onDeleteValue: (index: number) => void;
  onUpdateValue: (index: number, newValue: string) => void;
}

export const OptionKeyCard = (props: OptionKeyCardProps) => {
  const [clickedDelete, setClickedDelete] = useState(false);
  const [showUpdateDialog, setShowUpdateDialog] = useState(false);
  const [showValueDialog, setShowValueDialog] = useState(false);

  const resolvedName = props.selectedLocale
    ? props.optionKey.nameTranslation[props.selectedLocale] ?? ''
    : props.optionKey.key;

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        p: 1.5,
      }}
    >
      <UpsertOptionKeyDialog
        open={showUpdateDialog}
        initialValue={resolvedName}
        selectedLocale={props.selectedLocale}
        defaultValue={props.optionKey.key}
        onUpsert={(x) => {
          props.onUpdateName(x);

          if (props.selectedLocale) {
            setShowUpdateDialog(false);
          }
        }}
        onClose={() => setShowUpdateDialog(false)}
      />
      <UpsertOptionValueDialog
        open={showValueDialog}
        onUpsert={(value) => {
          setShowValueDialog(false);
          props.onAddValue(value);
        }}
        selectedLocale={null}
        onClose={() => setShowValueDialog(false)}
      />
      {clickedDelete && (
        <ConfirmDialog
          content='Gerçekten seçili seçeneği silmek istiyor musunuz'
          open={clickedDelete}
          onClose={() => setClickedDelete(false)}
          onConfirm={props.onDelete}
          color='error'
        />
      )}
      {!props.selectedLocale && (
        <IconButton color='error' onClick={() => setClickedDelete(true)}>
          <DeleteIcon />
        </IconButton>
      )}
      <Box
        onClick={() => setShowUpdateDialog(true)}
        sx={{
          width: 120,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Typography sx={{ ...sharedStyles.body1, fontWeight: 'bold' }}>
          {resolvedName || props.optionKey.key}
        </Typography>

        {!resolvedName && !!props.selectedLocale && (
          <TranslateIcon color='error' fontSize='small' />
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 1,
          flexWrap: 'wrap',
          gap: 1.5,
        }}
      >
        {props.optionKey.values.map((value, i) => (
          <OptionValueChip
            key={i}
            value={value}
            selectedLocale={props.selectedLocale}
            onDelete={
              props.optionKey.values.length > 1
                ? () => props.onDeleteValue(i)
                : undefined
            }
            onUpdate={(newValue) => props.onUpdateValue(i, newValue)}
          />
        ))}

        {!props.selectedLocale && (
          <Button
            color='primary'
            onClick={() => setShowValueDialog(true)}
            sx={{ ...sharedStyles.buttonText }}
          >
            + Yeni Değer
          </Button>
        )}
      </Box>
    </Paper>
  );
};
